import { Permissoes } from './../model/permissao.model';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PermissoesService {

  baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  getAll(params: any): Observable<any>{
    const url = `${this.baseUrl}permissoes`;
    return this.http.get<any>(url, {params})
  }

  listarService(): Observable<Permissoes[]>{
    const url = `${this.baseUrl}permissoes/listarTodos`;
    return this.http.get<Permissoes[]>(url);
  }

  listarPorIdService(id: any): Observable<Permissoes>{
    const url = `${this.baseUrl}permissoes/${id}`;
    return this.http.get<Permissoes>(url)
  }

  cadastrarService(permissao: Permissoes): Observable<Permissoes>{
    const url = `${this.baseUrl}permissoes/cadastro`;
    return this.http.post<Permissoes>(url, permissao);
  }

  atualizarService(permissao: Permissoes): Observable<Permissoes>{
    const url = `${this.baseUrl}permissoes/atualizar/${permissao.sr_id}`;
    return this.http.put<Permissoes>(url, permissao);
  }
}
